import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import DatePicker from "react-datepicker";
import Common from "../../Common/Common";
import "./TripAI.css";

// Shared by BuildMyTripWizard.js and TripAI.js's own destination lists — same
// tai-dest-* markup, previously maintained as two near-identical copies.
const DestinationCard = ({
  dest,
  index,
  showDelete,
  cityLabel,
  headerExtra,
  // Optional free-text description row (e.g. a noSearch waypoint's "Hotel",
  // "Fuel Stop") — only rendered when showLabelField is true, since most
  // callers (a normal real destination) have no use for it.
  showLabelField,
  labelValue,
  onChangeLabel,
  onSelectCountry,
  onSelectCity,
  onChangeStart,
  onChangeEnd,
  onRemove,
  // placeLocked: the country and city are shown but can't be changed (Build
  // My Trip's "This guide's places" — they come from the places). 2026-10-17.
  placeLocked = false,
}) => (
  <div className="tai-dest-card">
    <div className="tai-dest-header">
      <span className="tai-dest-num">{index + 1}</span>
      {headerExtra}
      {showDelete && (
        <button className="tai-dest-delete" onClick={onRemove}>
          <FontAwesomeIcon icon={solid("xmark")} />
        </button>
      )}
    </div>
    {showLabelField && (
      <>
        <div className="tai-input-row">
          <span className="tai-input-label">Label</span>
          <input
            className="tai-input-field"
            placeholder="e.g. Hotel, Fuel Stop"
            value={labelValue || ""}
            onChange={(e) => onChangeLabel(e.target.value)}
          />
        </div>
        <div className="tai-divider" />
      </>
    )}
    <div className="tai-row-item" onClick={placeLocked ? undefined : onSelectCountry} style={placeLocked ? { cursor: "default" } : undefined}>
      <span className="tai-row-key">Country</span>
      {dest.country ? <span className="tai-row-value">{dest.country}</span> : null}
      {!placeLocked && (
        <span className="tai-row-chevron">
          <FontAwesomeIcon icon={solid("chevron-right")} />
        </span>
      )}
    </div>
    <div className="tai-divider" />
    <div className="tai-row-item" onClick={placeLocked ? undefined : onSelectCity} style={placeLocked ? { cursor: "default" } : undefined}>
      <span className="tai-row-key">{cityLabel || "City"}</span>
      {dest.city ? <span className="tai-row-value">{dest.city}</span> : null}
      {!placeLocked && (
        <span className="tai-row-chevron">
          <FontAwesomeIcon icon={solid("chevron-right")} />
        </span>
      )}
    </div>
    <div className="tai-divider" />
    <div className="tai-date-row">
      <span className="tai-row-key">From</span>
      <DatePicker showMonthDropdown showYearDropdown dropdownMode="select"
        selected={Common.JSDateFromLuxonDate(dest.dateStart)}
        onChange={onChangeStart}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={5}
        timeCaption="time"
        dateFormat="MMM d, yyyy HH:mm"
        withPortal
      />
    </div>
    <div className="tai-divider" />
    <div className="tai-date-row">
      <span className="tai-row-key">To</span>
      <DatePicker showMonthDropdown showYearDropdown dropdownMode="select"
        selected={Common.JSDateFromLuxonDate(dest.dateEnd)}
        onChange={onChangeEnd}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={5}
        timeCaption="time"
        dateFormat="MMM d, yyyy HH:mm"
        withPortal
      />
    </div>
  </div>
);

export default DestinationCard;
